import './main-content-section.scss';

import PropTypes from 'prop-types';

import React from 'react';

function MainContentSection(props) {
    let { className = '' } = props;
    return (
        <div className={ `main-content-section ${className}` }>
            { props.children }
        </div>
    );
}

MainContentSection.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default MainContentSection;


/** WEBPACK FOOTER **
 ** ./client/pages/layout/main-content/main-content-section.js
 **/